import { MapPin } from "lucide-react";
import { PALETTE, BG_PALETTE, parseDistance } from "../lib/theme";
import type { Section3 } from "../lib/types";

interface Props {
  data: Section3;
}

export function SectionEquipments({ data }: Props) {
  const sorted = [...data.equipements].sort(
    (a, b) => parseDistance(a.distance) - parseDistance(b.distance),
  );

  return (
    <div className="flex flex-col gap-1.5">
      {sorted.map((e, i) => (
        <div
          key={`eq-${i}`}
          className="flex items-center justify-between gap-3 rounded-lg px-3.5 py-3"
          style={{ background: i % 2 === 0 ? BG_PALETTE[2] : "#fff" }}
        >
          <span className="flex items-center gap-2 text-sm text-slate-800">
            <MapPin size={16} color={PALETTE[2]} strokeWidth={2} />
            {e.nom}
          </span>
          <span
            className="shrink-0 text-sm font-bold"
            style={{ color: PALETTE[2] }}
          >
            {e.distance}
          </span>
        </div>
      ))}
    </div>
  );
}
